// extracted by mini-css-extract-plugin
module.exports = {"trendingTitle":"TrendingTopics_trendingTitle__36DqE","cardsWrap":"TrendingTopics_cardsWrap__1rs6Z","trendingCard":"TrendingTopics_trendingCard__3b5ZC"};